import React from "react";
import "./mudatthev.css";

const GoldLoan = () => {
  return (
    <div className="goldloan-container">
      {/* Banner Section */}
      <div className="banner">
        <img src="/images/slider1.jpg" alt="Banner" />
      </div>

      {/* Button */}
      <div className="apply-btn">
        <button>आताच अप्लाय करा ➤</button>
      </div>

      {/* Two Columns */}
      <div className="gold-container">
        {/* Left Column */}
        <div className="gold-column">
          <h2>मुदत ठेव योजना</h2>
          <p>
            आपल्या संस्थेच्या मुदत ठेव योजनेंतर्गत आपण केलेली ठेव बँकेत ठेवलेल्या
            मुदतीनंतर व्याजासह परत मिळते. मुदत ठेव ही सुरक्षित आणि विश्वासार्ह
            गुंतवणूक पद्धत आहे.यामध्ये ठराविक कालावधीसाठी गुंतवणूक करून आपण आकर्षक व्याजदर मिळवू
            शकता.
          </p>
        </div>

        {/* Right Column */}
        <div className="gold-column">
          <h2>आवश्यक कागदपत्रे</h2>
          <ul>
            <li>फोटो</li>
            <li>आधारकार्ड</li>
            <li>पॅनकार्ड</li>
            <li>जमा रकम १०००/- पासून उपलब्ध</li>
          </ul>
        </div>
      </div>

      {/* Table Section */}
      <div className="table-section">
        <table>
          <thead>
            <tr>
              <th>मुदत</th>
              <th>व्याजदर</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>४५ दिवस ते ३ महिने</td>
              <td>४ %</td>
            </tr>
            <tr>
              <td>३ महिने ते ६ महिने</td>
              <td>५ %</td>
            </tr>
            <tr>
              <td>६ महिने ते १२ महिने</td>
              <td>६ %</td>
            </tr>
            <tr>
              <td>१२ महिने व त्यावरील मुदत</td>
              <td>१२ %</td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default GoldLoan;
